import { NgModule } from '@angular/core';

import { PessoaTipoPipe } from './pessoa-tipo.pipe';
import { PessoaTipoAbreviacaoPipe } from './pessoa-tipo-abreviacao.pipe';
import { PessoaTipoIconPipe } from './pessoa-tipo-icon.pipe';

@NgModule({
    imports: [],
    declarations: [
        PessoaTipoPipe,
        PessoaTipoAbreviacaoPipe,
        PessoaTipoIconPipe
    ],
    exports: [
        PessoaTipoPipe,
        PessoaTipoAbreviacaoPipe,
        PessoaTipoIconPipe
    ],
    providers: [
        PessoaTipoPipe,
        PessoaTipoAbreviacaoPipe,
        PessoaTipoIconPipe
    ]
})
export class PessoaTipoPipeModule { }
